import I18n from "../../I18n";

const mapCard = (json) => {
    const { id, ReportName, Active } = json;
    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
                align: "left",
                basis: "5%",
            },
        ],
        [
            {
                labels: ["ReportName"],
                value: ReportName,
                type: "string",
                align: "left",
                basis: "70%",
            },
        ],
        [
            {
                labels: ["Active"],
                value:
                Active && Active === 1
                        ? I18n.translate`Yes`
                        : I18n.translate`No`,
                type: "string",
                align: "center",
                basis: "10%",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["ID"], align: "left", columnName: "id", basis: "5%" },
    { label: ["Report Name"], align: "left", columnName: "ReportName", basis: "70%" },
    { label: ["Is Active?"], align: "center", columnName: "Active", basis: "10%" },
];

const CustomReportSettingsMapper = {
    map: mapper,
    header,
};

export default CustomReportSettingsMapper;